var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var pikaday = require('../../libs/pikaday');
var Model = require('../../libs/Model');
var loaders = require('../../layout/components/loaders');
var button = require('../../components/button');
var Point = require('../../data/models/point');
var c3 = require('../../libs/chart');

var pointChart = {};

pointChart.oninit = function (vnode) {
  var ctrl = this;
  ctrl.point = vnode.attrs.pointRecord;
  ctrl.args = vnode.attrs.column;
  ctrl.alarmProfile = vnode.attrs.alarmProfile;
  ctrl.noData = false;

  if (ctrl.args && ctrl.args['@rid']) {
    ctrl.column = ctrl.args['@rid'];
  }

  ctrl.form = {
    start: prop(null),
    span: prop(24),
    resampling: prop('hours')
  };

  ctrl.download = function (evt) {
    //evt.preventDefault()
    var data = {};
    if (ctrl.form.start()) {
      data['start'] = moment(ctrl.form.start()).valueOf();
    }
    else {
      data['start'] = moment().valueOf();
    }
    data['span'] = ctrl.form.span();
    data['resample'] = ctrl.form.resampling();
    if (ctrl.column) {
      data['column'] = ctrl.column;
    }
    // Starts download
    window.location = '/api/v1/data/' + ctrl.point['@rid'].slice(1) + '/xlsx?' + Model.serialize(data);
  };

  ctrl.getChart  = function (params) {
    if(params && params.pointRecord){
      ctrl.point = params.pointRecord;
    }
    if(params && params.column){
      ctrl.args = params.column;
    }

    if(params && params.alarmProfile){
      ctrl.alarmProfile = params.alarmProfile;
    }else{
      ctrl.alarmProfile = false
    }
    var data = {};
    if (ctrl.form.start()) {
      data['start'] = moment(ctrl.form.start()).valueOf();
    }
    else {
      data['start'] = moment().valueOf();
    }
    data['span'] = ctrl.form.span();
    data['resample'] = ctrl.form.resampling();

    return loaders.requestWithLoader({
      loader: 'background',
      url: '/api/v1/data/' + String(ctrl.point['@rid']).slice(1) ,
      params: data,
      method: 'GET',
      background: true,
    })
    .then(function (response) {
      // Hide Loading Spinner
      loaders.background.stop();
      // See if there's any data in the series
      if (typeof response.data.columns === 'undefined' || response.data.length == 0 ) {
        ctrl.noData = true;
        ctrl.chart.load({unload: true});
        m.redraw();
        return
      }
      else {
        ctrl.noData = false;
      }

      m.redraw();
      // Reformat data for c3
      response.data.columns[0] = 'x';
      // response.data.columns[1] = ctrl.point.name + ' (' + Point.formatUnit(ctrl.point) + ')';

      var rows = [];
      // Convert Time Stamp (Someday use TZ from user profile)
      response.data.values.slice(1).forEach(function (arr) {
        if (typeof arr[1] == null) { return }
        var ts = moment.tz(arr[0], 'UTC');
        arr[0] = ts.clone().tz('America/New_York').valueOf();
        arr[1] = Point.readValue({unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: arr[1]}, true);
        arr[2] = Point.readValue({unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: arr[2]}, true);
        arr[3] = Point.readValue({unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: arr[3]}, true);
        rows.push(arr)
      });
      rows.unshift(response.data.columns); // Remove Influx Sequence #
      // Set chart type depending on point type
      var chart_type = ctrl.point.unit == 'bool' ? 'area-step': 'line';
 
      // Package all that up for c3 chart.load()
      var chartData = {
        rows: rows,
        type: chart_type,
        unload: true
      };

      try {
        var regions = [];

        if (ctrl.point.alarmHiLimit) {
          regions.push({
            axis: 'y',
            start: Point.readValue({ unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: ctrl.point.alarmHiLimit }),
            class: 'region-red'
          })
        }

        if (ctrl.point.alarmLoLimit) {
          regions.push({
            axis: 'y',
            end: Point.readValue({ unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: ctrl.point.alarmLoLimit }),
            class: 'region-red'
          })
        }
        if(ctrl.alarmProfile && ctrl.alarmProfile.triggers && Array.isArray(ctrl.alarmProfile.triggers) && ctrl.alarmProfile.triggers.length > 0){
          let triggerHi = ctrl.alarmProfile.triggers.filter( triggerRecord => triggerRecord.triggerType == "hi");
          let triggerLo = ctrl.alarmProfile.triggers.filter( triggerRecord => triggerRecord.triggerType == "lo");
          let valueTriggerLo = parseInt(triggerHi.sort((a,b)=>parseInt(a.scalar)-parseInt(b.scalar))[0].scalar);
          let valuTriggereHi = parseInt(triggerLo.sort((a,b)=>parseInt(b.scalar)-parseInt(a.scalar))[0].scalar);

          regions.push({
            axis: 'y',
            start: Point.readValue({ unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: valueTriggerLo }),
            class: 'region-red'
          })
          regions.push({
            axis: 'y',
            end: Point.readValue({ unit: ctrl.point.unit, destUnit: ctrl.point.destUnit, displayUnit: ctrl.point.displayUnit, value: valuTriggereHi }),
            class: 'region-red'
          })
        }
        ctrl.chart.regions(regions)
        ctrl.chart.load(chartData);
      } catch (e) {
        setTimeout(function () {
          ctrl.chart.load(chartData);
        }, 500);
      }

    })
  };

  ctrl.getChart();
  vnode.state.getChart = ctrl.getChart;
};

pointChart.view = function() {
  var ctrl = this
  return m('div', [
    m(c3, {oncreate: function (vnode) {
      ctrl.chart = vnode.state.chart;
    }}),
    m('div.dn.db-m.db-l',[
      m('div.flex.justify-between.flex-wrap', [
        m('div', [
          m('form.flex.justify-center', {role:'form'}, [
            m('div.mr2', [
              m('label', {for: 'span-input'}, 'Span'),
              m('input.mb0.w4', {
                id: 'span-input',
                style: {width:'5em'},
                type: 'number',
                autocomplete: 'off',
                value: ctrl.form.span(),
                oninput: function (ev) { ctrl.form.span(ev.target.value)},
              }), // Value handled by pikadate
            ]),  
            m('div.mr2', [
              m('label', {for: 'sampling-input'}, 'Sampling'),
              m('select.input-reset.mb0.w4', {
                id: 'sampling-input',
                autocomplete: 'off',
                onchange: function (ev) { ctrl.form.resampling(ev.target.value)} 
              }, [
                m('option', {value: 'hours'}, 'Hours (15m)'),
                m('option', {value: 'hour'}, 'Hours'),
                m('option', {value: 'days'}, 'Days'),
                m('option', {value: 'minutes'}, 'Minutes'),
                m('option', {value: 'seconds'}, 'Seconds'),
                m('option', {value: 'milliseconds'}, 'Milliseconds')
              ])
            ]),
            m('div', {style: {width: '11.5em'}}, [
              m('label', {for: 'end-date'}, 'Ending'),
              m(pikaday, {value: ctrl.form.start, dateFormat: 'm/d/Y h:i K'})
            ])
          ])
        ]),
        m('div.mt3.tc.flex.justify-end', [
          m(button, {func: ctrl.download.bind(ctrl), label: m('span.green', ['Export', m('i.ion-document.ml2')]), class: 'mr2 w4'}),
          m(button, {func: ctrl.getChart.bind(ctrl), label: m('span.blue', ['Chart', m('i.ion-arrow-graph-up-right.ml2')]), class: 'w4'})
        ])
      ])
    ]),
    // Different for small screen
    m('div.dn-m.dn-l', [
      m('div.mb2', [
        m('label', {for: 'span-input'}, 'Span'),
        m('input.mb0.w4', {
          id: 'span-input',
          style: {width:'100%'},
          type: 'number',
          autocomplete: 'off',
          value: ctrl.form.span(),
          oninput: function (ev) { ctrl.form.span(ev.target.value)},
        }) // Value handled by pikadate
      ]),  
      m('div.mb2', [
        m('label', {for: 'sampling-input'}, 'Sampling'),
        m('select.input-reset.mb0.w-100', {
          id: 'sampling-input',
          autocomplete: 'off',
          onchange: function (ev) { ctrl.form.resampling(ev.target.value)} 
        }, [
          m('option', {value: 'hours'}, 'Fifteen Minutes'),
          m('option', {value: 'hour'}, 'Hours'),
          m('option', {value: 'days'}, 'Days'),
          m('option', {value: 'minutes'}, 'Minutes'),
          m('option', {value: 'seconds'}, 'Seconds'),
          m('option', {value: 'milliseconds'}, 'Milliseconds')
        ])
      ]),
      m('div.mb2', {style: {width: '100%'}}, [
        m('label', {for: 'end-date'}, 'Ending'),
        m(pikaday, {value: ctrl.form.start, dateFormat: 'm/d/Y h:i K'})
      ]),
      m('div.mt3.tc.flex', [
        m(button, {func: ctrl.download.bind(ctrl), label: m('span.green', ['Export', m('i.ion-document.ml1')]), class: 'w-50 mr1'}),
        m(button, {func: ctrl.getChart.bind(ctrl), label: ['Chart', m('i.ion-arrow-graph-up-right')], class: 'w-50 ml1 blue'})
      ])
    ]),
    m('div.flex.justify-center', [
      m('p.tc.mw7', 
      {style:{color:'#ddd',display: ctrl.noData ? "block" : "none"}}, 
      'No data was found for the range selected. Selecting a different range may help. If more data is needed, it may be good to reconfigure sampling for this point.'
      )
    ])
  ]);
};

module.exports = pointChart;
